import React, { useEffect, useState } from 'react';
import { ValidatorForm } from 'react-form-validator-core';
import { useLastLocation } from 'react-router-last-location';
import { useHistory } from 'react-router-dom';

import { Button, TextArea } from '../../Atoms';
import useToaster from '../../components/Toaster/useToaster';
import FeedbackImage from '../../Assets/feedback.png';
import '../Feedback/feedback.scss';
import { sendFeedback, reset } from '../../redux/actions/ManagerAction';
import { connect } from 'react-redux';

const FeedbackModal = ({
  sendFeedback,
  feedback: { loading, success, error },
  reset,
}) => {
  const lastLocation = useLastLocation();
  const history = useHistory();
  const { toast } = useToaster();
  const [feedback, setFeedback] = useState('');

  const handleChange = ({ target: { value } }) => {
    setFeedback(value);
  };

  useEffect(() => {
    if (!loading && success) {
      toast({ text: 'Your feedback has been submitted' });
      setFeedback('');
      reset('feedback');
      history.push(lastLocation ? lastLocation.pathname : '/');
    }

    if (!loading && error) {
      toast({ text: error, type: 'error' });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, success, error]);
  const handleSubmit = () => {
    sendFeedback({ message: feedback });
  };

  return (
    <div className="feedback-modal">
      <h3>Here To Listen</h3>
      <img src={FeedbackImage} alt="feedback" />
      <div className="description">
        Please use this space to vent and share 
        what you are struggling with so we can help. 
        We hope your experience with Peak Mind has been 
        positive and has made an impact in your life.
      </div>
      <ValidatorForm onSubmit={handleSubmit} className="form">
        <div className="feedback-form">
          <TextArea
            title="Feedback"
            value={feedback}
            onChange={handleChange}
            formValid={true}
            validators={['required']}
            errorMessages={['this field is required']}
          />
        </div>
        <Button
          type="submit"
          size="form-md"
          color="blue"
          className="align-self-center"
          onClick={handleSubmit}
          disabled={!feedback}
          loading={loading}
        >
          Submit Feedback
        </Button>
      </ValidatorForm>
    </div>
  );
};

const mapStateToProps = (state) => ({
  feedback: state.manager.feedback,
});

const mapDispatchToProps = (dispatch) => ({
  sendFeedback: (details) => {
    dispatch(sendFeedback(details));
  },
  reset: (block) => {
    dispatch(reset(block));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackModal);
